
export const adminRoutes = [
    {
        path: '/siteadmin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/dashboard'));
        }),
    },
    // AUDIT: removed React-Starter-Kit demo routes /inputform and /table (unlinked, top-level paths).
    {
        path: '/siteadmin/users', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/users'));
        }),
    },
    {
        path: '/siteadmin/partners',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/partners'));
        }),
    },
    {
        path: '/siteadmin/category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/category'));
        }),
    },
    {
        path: '/siteadmin/sections',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/sections'));
        }),
    },
    {
        path: '/siteadmin/messaging',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/messaging'));
        }),
    },
    {
        path: '/siteadmin/sub-category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/subCategory'));
        }),
    },
    {
        path: '/siteadmin/jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/booking'));
        }),
    },
    {
        path: '/siteadmin/category/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addCategory'));
        }),
    },
    {
        path: '/siteadmin/sub-category/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addSubCategory'));
        }),
    },
    {
        path: '/siteadmin/:from/view/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/viewBooking'));
        }),
    },
    {
        path: '/siteadmin/users/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editUser'));
        }),
    },
    {
        path: '/siteadmin/partners/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editPartner'));
        }),
    },
    {
        path: '/siteadmin/category/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editCategory'));
        }),
    },
    {
        path: '/siteadmin/sub-category/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editSubCategory'));
        }),
    },
    {
        path: '/siteadmin/promo-code/list',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/promoCodeList'));
        }),
    },
    {
        path: '/siteadmin/promo-code/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/addPromoCode'));
        }),
    },
    {
        path: '/siteadmin/promo-code/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/editPromoCode'));
        }),
    },
    {
        path: '/siteadmin/completed-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/completedBooking'));
        }),
    },
    {
        path: '/siteadmin/cancelled-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/cancelledBooking'));
        }),
    },
    {
        path: '/siteadmin/unfulfilled-bookings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/operationalAlerts/unfulfilledIndex'));
        }),
    },
    {
        path: '/siteadmin/stalled-bookings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/operationalAlerts/stalledIndex'));
        }),
    },
    {
        path: '/siteadmin/booking-attempts',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bookingAttempts'));
        }),
    },
    {
        path: '/siteadmin/currency',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/currency'));
        }),
    },
    {
        path: '/siteadmin/settings/site', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/siteSettings'));
        }),
    },
    {
        path: '/siteadmin/change/admin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/changeAdmin'));
        }),
    },
    {
        path: '/siteadmin/notifications',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/notifications'));
        }),
    },
    {
        path: '/siteadmin/cancel-reasons',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageCancelReasons'));
        }),
    },
    {
        path: '/siteadmin/seo/edit/:id', // edit a single SEO landing page
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/seo/edit'));
        }),
    },
    {
        path: '/siteadmin/seo',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/seo'));
        }),
    },
    {
        path: '/siteadmin/refunds',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/refundsDisputes'));
        }),
    },
    {
        path: '/siteadmin/satisfaction-claims', // Standard-booking satisfaction-guarantee claims (listBookingClaims via besthand-api)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/satisfactionClaims'));
        }),
    },
    {
        path: '/siteadmin/job-contests',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/jobContests'));
        }),
    },
    {
        path: '/siteadmin/unsettled-payments',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/unsettledPayments'));
        }),
    },
    {
        path: '/siteadmin/analytics',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/analytics'));
        }),
    },
    {
        path: '/siteadmin/audit-log',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/auditLog'));
        }),
    },
    {
        path: '/siteadmin/growth',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/growth'));
        }),
    },
    {
        path: '/siteadmin/prospecting/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/prospecting'));
        }),
    },
    {
        path: '/siteadmin/category-questions',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/categoryQuestions'));
        }),
    },
    {
        path: '/siteadmin/worker-performance',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/workerPerformance'));
        }),
    },
    {
        path: '/siteadmin/user-360',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/user360'));
        }),
    },
    {
        path: '/siteadmin/review-moderation',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/reviewModeration'));
        }),
    },
    {
        path: '/siteadmin/support',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/support'));
        }),
    },
    {
        path: '/siteadmin/finance',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/finance'));
        }),
    },
    {
        path: '/siteadmin/ratings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/ratings'));
        }),
    },
    {
        path: '/siteadmin/cancel-reasons/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addCancelReason'));
        }),
    },
    {
        path: '/siteadmin/cancel-reasons/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editCancelReason'));
        }),
    },
    {
        path: '/siteadmin/add-location',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addLocation'));
        }),
    },
    {
        path: '/siteadmin/location',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageLocationList'));
        }),
    },
    {
        path: '/siteadmin/edit-location/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editLocation'));
        }),
    },
    {
        path: '/siteadmin/homepage/banner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/homeSettings'));
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/categorySettings'));
        }),
    },
    {
        path: '/siteadmin/homepage/category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/citySettings'));
        }),
    },
    {
        path: '/siteadmin/homepage/user',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/safetySettings'));
        }),
    },
    {
        path: '/siteadmin/homepage/partner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/signupSettings'));
        }),
    },
    {
        path: '/siteadmin/homepage/footer',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/footerSettings'));
        }),
    },
    {
        path: '/siteadmin/payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/autoPayout'));
        }),
    },
    {
        path: '/siteadmin/failed-payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/failedPayout'));
        }),
    },
    {
        path: '/siteadmin/deferred-background-checks',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/deferredBackgroundChecks'));
        }),
    },
    {
        path: '/siteadmin/free-background-checks',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/freeBackgroundChecks'));
        }),
    },
    {
        // COMPLIANCE / FCRA adverse-action sequence (PRE_ADVERSE -> wait -> FINAL).
        path: '/siteadmin/adverse-action',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/adverseAction'));
        }),
    },
    {
        path: '/siteadmin/available-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/availableJobs'));
        }),
    },
    {
        path: '/siteadmin/staticpage/manage',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/staticPage'));
        }),
    },
    {
        path: '/siteadmin/contentpage/manage', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/contentPage'));
        }),
    },
    {
        path: '/siteadmin/contentpage/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addContentPage'));
        }),
    },
    {
        path: '/siteadmin/contentpage/edit/:pageId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editContentPage'));
        }),
    },
    {
        path: '/siteadmin/staticpage/edit/:pageId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editStaticPage'));
        }),
    },
    {
        path: '/siteadmin/pricing/list',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/pricingList'));
        }),
    },
    {
        path: '/siteadmin/pricing/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/addPricing'));
        }),
    },
    {
        path: '/siteadmin/pricing/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/editPricing'));
        }),
    },
    {
        path: '/siteadmin/admin-roles',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/adminRoles'));
        }),
    },
    {
        path: '/siteadmin/admin-users',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/adminUser'));
        }),
    },
    {
        path: '/siteadmin/precaution-notification', // Completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/precautionNotification/updatePrecautionNotification'));
        }),
    },
    {
        path: '/siteadmin/:from/chat-message/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/chatMessage'));
        }),
    },
    {
        path: '/siteadmin/settings/mobile-app', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/mobileSettings'));
        }),
    },
    {
        path: '/siteadmin/regions', // geographic expansion control (G1)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/regions'));
        }),
    },
    {
        path: '/siteadmin/community-discount', // Senior & Veteran discount program
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/communityDiscount'));
        }),
    },
    // CONSOLIDATION (2026-06): removed /big-projects/companies (CompanyProviders.js,
    // the PENDING-only KYB queue). "Manage Company" below is a strict superset
    // (all companies + status filter + search + every action the old page had,
    // plus Middesk/Stripe auto-verify). No action lost.
    {
        path: '/siteadmin/big-projects/manage-company', // Large Projects — Manage Company (full company directory: adminListCompanies)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjects/manage-company'));
        }),
    },
    {
        path: '/siteadmin/big-projects/sectors', // Large Projects — Sectors catalog (self-growing company domains)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjects/sectors'));
        }),
    },
    {
        path: '/siteadmin/big-projects/visit-fee', // Large Projects — Visit Fee settings (toggle + amount)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsVisitFee'));
        }),
    },
    {
        path: '/siteadmin/big-projects/escrow-rules', // Large Projects — Escrow Rules (threshold + per-category overrides)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsEscrowRules'));
        }),
    },
    {
        path: '/siteadmin/big-projects/payment-methods', // Large Projects — Payment Methods (card always on; Affirm/Klarna toggles) — SEPARATE from small jobs
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsPaymentMethods'));
        }),
    },
    {
        path: '/siteadmin/big-projects/requests', // Large Projects — Project Requests admin list (adminListProjectRequests)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsRequests'));
        }),
    },
    {
        path: '/siteadmin/big-projects/quotes', // Large Projects — Quotes admin list (adminListQuotes)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsQuotes'));
        }),
    },
    {
        path: '/siteadmin/big-projects/contracts', // Large Projects — Contracts admin list (listActiveContracts)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsContracts'));
        }),
    },
    {
        path: '/siteadmin/big-projects/milestones', // Large Projects — Milestones admin list (read-only, adminListProjectMilestones)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsMilestones'));
        }),
    },
    {
        path: '/siteadmin/big-projects/disputes', // Large Projects — Disputes admin list (listOpenDisputes)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsDisputes'));
        }),
    },
    {
        path: '/siteadmin/big-projects/funds', // Large Projects — Funds held / escrow (listFundsHeld)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsFunds'));
        }),
    },
    {
        path: '/siteadmin/big-projects/jurisdictions', // Large Projects — Jurisdiction rules (listJurisdictions)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsJurisdictions'));
        }),
    },
    {
        path: '/siteadmin/big-projects/legal-docs', // Large Projects — Legal documents (listLegalDocuments)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsLegalDocs'));
        }),
    },
    {
        path: '/siteadmin/big-projects/dsar', // Large Projects — DSAR requests (listPendingDsarRequests)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsDsar'));
        }),
    },
    {
        path: '/siteadmin/big-projects/audit-log', // Large Projects — Audit log (listProjectAuditLog)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsAuditLog'));
        }),
    },
    {
        path: '/siteadmin/big-projects/breach', // Large Projects — Breach notifications (listBreachNotifications)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsBreach'));
        }),
    },
    {
        path: '/siteadmin/big-projects/circumvention', // Large Projects — Circumvention attempts (listCircumventionAttempts)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/bigProjectsCircumvention'));
        }),
    },
    // REMOVED /big-projects/categories (manageLargeProjectCategories): it edited a
    // besthand-web-DB largeProject=true catalog that NOTHING consumes — the
    // Post-a-Project wizard uses a fixed 7-value enum and submits to besthand-api
    // (separate DB), and every public/SEO/search reader excludes largeProject=true.
    // The page was decorative and misleading. (Option B.) Component files retained
    // but unreachable.
    {
        path: '/siteadmin/settings/marketing', // marketing & tracking (pixels, GA4, retargeting)
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/marketing'));
        }),
    },
    {
        path: '/siteadmin/tracking',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/tracking'));
        }),
    },
    {
        path: '/siteadmin/sms-methods',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/smsMethod'));
        }),
    },
    {
        path: '/siteadmin/sms-method/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/smsMethod/editSmsMethod'));
        }),
    },
    {
        path: '/siteadmin/schedule-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/scheduleBooking'));
        }),
    },
    {
        path: '/siteadmin/settings/config', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/configSettings'));
        }),
    },
    {
        path: '/siteadmin/payment-gateway',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/paymenGateway'));
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addTopFeature'));
        }),
    },
    {
        path: '/siteadmin/partners/category/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageCategory'));
        }),
    },
    {
        path: '/siteadmin/partners/sub-category/:id/:categoryid',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageSubCategory'));
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editTopFeature'));
        }),
    },
    {
        path: '/siteadmin/manual-bookings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manualBooking'));
        }),
    },
    {
        path: '/siteadmin/manual-bookings/create',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addManualBooking'));
        }),
    },
    {
        path: '/siteadmin/provider-onboarding-screens',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/providerOnboardingScreens'));
        }),
    },
    {
        path: '/siteadmin/provider-onboarding-screens/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addOnBoardingScreens'));
        }),
    },
    {
        path: '/siteadmin/provider-onboarding-screens/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editOnBoardingScreens'));
        }),
    },
];